import Resource from "./Resource";

export default class AccessoryResource extends Resource {
  remove(projectId: number, roomId: number, accessoryId: number) {
    return this.http.delete(`projects/${projectId}/rooms/${roomId}/accessories/${accessoryId}`);
  }
}
